import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MessageObj} from "mx-core";
import {MessageTextLineBean} from "../../../../../../bo/generated/generated.model";
import {MessageResponse} from "../../../models/message.model";

const messages_api_url = 'rest/messages/';

@Injectable({
    providedIn: 'root'
})

export class PortalMessageService {

    constructor(private httpClient: HttpClient) {
    }

    public getMessage(id: number): Observable<MessageObj> {
        return this.httpClient.get<MessageObj>(messages_api_url + id);
    }

    public getMessages(): Observable<MessageResponse> {
        return this.httpClient.get<MessageResponse>(messages_api_url);
    }

    public sendMessage(message: { subject: any; body: any }): Observable<void> {
        return this.httpClient.post<void>(messages_api_url + 'send', message);
    }

    public sendReply(id: number, message: string): Observable<void> {
        return this.httpClient.post<void>(messages_api_url + 'reply/' + id, message);
    }

    public getLastMessage(subChainId: number): Observable<MessageTextLineBean> {
        return this.httpClient.get<MessageTextLineBean>(messages_api_url + 'last-message/' + subChainId);
    }

    public markAsDeleted(messageIds: number[]): Observable<void> {
        return this.httpClient.put<void>(messages_api_url + 'delete/', messageIds);
    }

    public markAsRead(subChainIds: number[]): Observable<void> {
        return this.httpClient.put<void>(messages_api_url + 'read/', subChainIds);
    }
}
